import { getData } from "@/utils/http";
import Big from "big-js";
export default {
  namespaced: true,
  state: {
    activeTab: "1",
    waybillId: "",

    //运单
    waybillItem: null,

    activeItem: {},
  },
  mutations: {
    CHANGE_ACTIVE_ITEM(state, item) {
      const expenseAccountList = [];

      Object.keys(item.expenseAccount).forEach((key) => {
        const list = item.expenseAccount[key].filter((ds) => {
          return ds.status != 99;
        });

        const totalAmount = list.reduce((sum, item) => {
          return new Big(sum).plus(item.amount).valueOf();
        }, 0);

        expenseAccountList.push({
          title: key,
          tableList: item.expenseAccount[key],
          defautlExpendIds: item.expenseAccount[key].map((item) => item.id),
          totalAmount,
        });
      });
      item.expenseAccountList = expenseAccountList;
      state.activeItem = item;
      console.log(item);
    },
    CHANGE_TAB(state, item) {
      state.activeTab = item;
    },
    CHANGE_WAYBILLID(state, item) {
      state.waybillId = item;
    },
    CHANGE_WAYBILL_ITEM(state, item) {
      state.waybillItem = item;
    },
  },
  actions: {
    setWaybillId({ commit }, id) {
      commit("CHANGE_WAYBILLID", id);
    },
    setWaybillItem({ commit }, item) {
      commit("CHANGE_WAYBILL_ITEM", item);
    },
    setTabData({ commit }, changeData) {
      commit("CHANGE_TAB", changeData);
    },
    //获取运单报销数据
    getfinance({ commit, state }) {
      return new Promise((resolve) => {
        getData(
          `logistics/finance/get/${state.waybillId}?type=${state.activeTab}`
        ).then((res) => {
          if (res.state == 1) {
            commit("CHANGE_ACTIVE_ITEM", res.data);

            resolve({
              state: 1,
              msg: "操作成功",
              data: res.data,
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
              data: [],
            });
          }
        });
      });
    },
    //写入当前操作条目
    setActiveItem({ commit }, item) {
      commit("CHANGE_ACTIVE_ITEM", item);
    },
    // 批量操作报销
    batchReimburse({ state }, id) {
      return new Promise((resolve) => {
        getData(
          `logistics/finance/account/all/submit?waybillId=${id}&type=${state.activeTab}`
        ).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: "操作成功",
              data: res.data,
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
              data: [],
            });
          }
        });
      });
    },
  },
};
